import type { RootState } from "../../redux";
import type { InfoPageState } from "../../types";
import { validateUserIsraeliIdAction, validateUserRegNumAction } from "../RegistrationPage/RegistrationPageSlice";
import { createSlice, isAnyOf } from "@reduxjs/toolkit";

const initialState: InfoPageState = {
  email: null,
  phoneNumber: null,
  isSMS: null,
};

export const infoPageSlice = createSlice({
  name: "infoPage",
  initialState,
  reducers: {
    setEmail: (state, { payload }: { payload: string | null }) => {
      state.email = payload;
    },

    setPhoneNumber: (state, { payload }: { payload: string | null }) => {
      state.phoneNumber = payload;
    },

    setIsSMS: (state, { payload }: { payload: boolean | null }) => {
      state.isSMS = payload;
    },

    resetInfoPageState: () => initialState,
  },

  extraReducers(builder) {
    builder.addMatcher(
      isAnyOf(validateUserRegNumAction.fulfilled, validateUserIsraeliIdAction.fulfilled),
      (state, { payload }) => {
        state.email = payload!.email;
        state.phoneNumber = payload!.phoneNumber;
        state.isSMS = payload!.isSMS;
      }
    );
  },
});

export const { setEmail, setIsSMS, setPhoneNumber, resetInfoPageState } = infoPageSlice.actions;

export const selectEmail = (state: RootState) => state.infoPage.email;
export const selectPhoneNumber = (state: RootState) => state.infoPage.phoneNumber;
export const selectIsSMS = (state: RootState) => state.infoPage.isSMS;

export default infoPageSlice.reducer;
